import React, { useEffect, useState } from "react";
import {Typography,Drawer,List,ListItem,Box,Button} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from '@mui/icons-material/Close';
import {useLocation, Link } from "react-router-dom";
import { PublicNavebarData } from "../assets/Json/navbarData";
import LogoImg from "../assets/images/jb-logo-png.png"
import { useDispatch } from "react-redux";
import { fetchBlogs } from "../store/blogs/blogBaseApi";
import { fetchCarousels } from "../store/carousel/carouselBaseApi";
import { fetchReviews } from "../store/googleReviews/googleReviewBaseApi";
import { fetchCategories } from "../store/category/categoryBaseApi";
import { fetchVrImages } from "../store/vrImages/vrImageBaseApi";

const Navbar = () => {
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [navItems, setNavItems] = useState(PublicNavebarData)
  const [scrolled,setScrolled] = useState(false);
 
  const location = useLocation();
  const handleScroll=() => {
    const offset=window.scrollY;
    if(offset > 50 ){
      setScrolled(true);
    }
    else{
      setScrolled(false);
    }
  }

  
  useEffect(() => {
     dispatch(fetchBlogs());
     dispatch(fetchCarousels());
     dispatch(fetchReviews());
     dispatch(fetchCategories());
    //  dispatch(fetchVrImages());
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener('scroll',handleScroll)
  })

  let x=['navbar shadow'];
  if(scrolled){
    x.push('scrolled');
  }
  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <Box className={x.join(" ")} >         
        <Box sx={{width:"100%",height:"50px"}} className='px-4'>
          {/* Brand or Logo */}
          <div className="navbarMenus">
             <div>
              <Typography variant="h6" sx={{ flexGrow: 1 }}>           
              <Link to="/home"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      // fontWeight: "bold",
                    }}
                  >

              <img src={LogoImg} height={50} alt='architects in tirunelveli'/>
                  </Link>
              </Typography>
              </div>
              <div>
              {/* Desktop Menu */}
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                {navItems.map((item,idx) => (
                  <Button key={idx} sx={{ color: "#fff" }}>
                  <Link to={item.path}
                    style={{
                      color: "black",
                      textDecoration: "none",
                      // fontWeight: "bold",
                    }}
                  >{item.name}</Link>
                  </Button>
                ))}
              </Box>

              {/* Mobile Menu Icon */}
              {
                !drawerOpen 
                   ? 
                   <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ display: { sm: "none" } }}
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton> 
              : 
              <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ display: { sm: "none" } }}
              onClick={toggleDrawer(true)}
            >
              <CloseIcon/>
            </IconButton>}
             
              </div>
          </div>
        </Box>
      {/* </AppBar> */}
    
      {/* Mobile Drawer */}
      <Drawer 
           open={drawerOpen} 
           onClose={toggleDrawer(false)}
           anchor="right" 
           PaperProps={{
             sx: { height: 'fit-content', borderRadius: 3,marginTop:8 }
           }}
           BackdropProps={{ sx: { backgroundColor: 'transparent' } }}
           >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            {navItems.map((item,idx) => {
                const isActive = location.pathname === item.path;
              return(
              //  <Link to="/about-us">{item}</Link>
              <ListItem button={"true"} key={idx}>
              {/* <ListItemText primary={item} /> */}
              <Link to={item.path}
                className={`${isActive ? 'navbarActive' : 'navbarNormal'}`}
              >{item.name}</Link>
              </ListItem>
            )})}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Navbar;
